function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.692 1.953h-1.078V0h-1.797v1.953H5.957V0H4.161v1.953H3.082c-1.486 0-2.695 1.314-2.695 2.93V22.07c0 1.616 1.21 2.93 2.695 2.93h17.61c1.486 0 2.695-1.314 2.695-2.93V4.883c0-1.616-1.209-2.93-2.695-2.93zm.898 20.117c0 .539-.403.977-.898.977H3.082c-.495 0-.898-.438-.898-.977V9.18H21.59v12.89zm0-14.843H2.184V4.883c0-.539.403-.977.898-.977h1.079V5.86h1.796V3.906h11.86V5.86h1.797V3.906h1.078c.495 0 .898.438.898.977v2.344z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.387 11h2v2h-2zM8.387 11h2v2h-2zM13.387 11h2v2h-2zM18.387 11h2v2h-2zM3.387 15h2v2h-2zM8.387 15h2v2h-2zM13.387 15h2v2h-2zM18.387 15h2v2h-2zM3.387 19h2v2h-2zM8.387 19h2v2h-2zM13.387 19h2v2h-2zM18.387 19h2v2h-2z"
}));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.215dd134.svg";
export { ForwardRef as ReactComponent };